import { render, staticRenderFns } from "./GuestsList.vue?vue&type=template&id=63299c60&"
import script from "./GuestsList.vue?vue&type=script&lang=js&"
export * from "./GuestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports